module.exports = __webpack_public_path__ + "settings.0d4200eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/settings.png
// module id = 843
// module chunks = 0